// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"32":"14f74a56","39":"5e8ebbcf","110":"1ff26df8","144":"350e8d0a","251":"34fd7ae2","311":"28391703","546":"900dd582","944":"56e14166"}[chunkId] + ".chunk.js";
};